"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomResponseOptionsSection = exports.ErrorWrapper = exports.ErrorContainer = exports.ErrorMessage = exports.FloatRightDiv = exports.LeftAlignDiv = exports.ResponseOptionsWrapper = exports.ResponseOptionGroupNameInput = void 0;
var aon_tws_common_ui_1 = require("@aon/aon-tws-common-ui");
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var ErrorMessage_1 = require("../../../components/common/errors/ErrorMessage");
var contentConstants_1 = __importDefault(require("../../../contentConstants"));
var models_1 = require("../../../models");
var utilities_1 = require("../../../utilities");
var common_1 = require("../../common");
var _1 = require("./");
exports.ResponseOptionGroupNameInput = (0, styled_components_1.default)(aon_tws_common_ui_1.Input).attrs({
    className: 'tws-custom-question-response-option-group',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
exports.ResponseOptionGroupNameInput.displayName = 'ResponseOptionGroupNameInput';
exports.ResponseOptionsWrapper = (0, styled_components_1.default)('div').attrs({
    className: 'tws-custom-response-options-selector',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tmargin: 40px 0;\n"], ["\n\tmargin: 40px 0;\n"])));
exports.LeftAlignDiv = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\twidth: 100%;\n\tmax-width: 550px;\n\ttext-align: left;\n\tdisplay: inline;\n"], ["\n\twidth: 100%;\n\tmax-width: 550px;\n\ttext-align: left;\n\tdisplay: inline;\n"])));
exports.LeftAlignDiv.displayName = 'LeftAlignDiv';
exports.FloatRightDiv = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tfloat: right;\n\tpadding-top: 10px;\n"], ["\n\tfloat: right;\n\tpadding-top: 10px;\n"])));
exports.ErrorMessage = styled_components_1.default.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\twidth: 100%;\n\tmax-width: 550px;\n\ttext-align: left;\n\tmargin-bottom: 6px;\n"], ["\n\twidth: 100%;\n\tmax-width: 550px;\n\ttext-align: left;\n\tmargin-bottom: 6px;\n"])));
exports.ErrorMessage.displayName = 'ErrorMessage';
exports.ErrorContainer = (0, styled_components_1.default)(common_1.ErrorContainer)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tmargin-top: 25px;\n"], ["\n\tmargin-top: 25px;\n"])));
exports.ErrorContainer.displayName = 'ErrorContainer';
exports.ErrorWrapper = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tmargin-bottom: 5px;\n"], ["\n\tmargin-bottom: 5px;\n"])));
exports.ErrorWrapper.displayName = 'ErrorWrapper';
var TogglesContainer = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\tmargin-top: 10px;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n"], ["\n\tmargin-top: 10px;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n"])));
TogglesContainer.displayName = 'TogglesContainer';
var CustomResponseOptionsSection = /** @class */ (function (_super) {
    __extends(CustomResponseOptionsSection, _super);
    function CustomResponseOptionsSection(props) {
        var _this = _super.call(this, props) || this;
        _this.inputRef = React.createRef();
        _this.UploadResponseOptionsTemplate = function () {
            if (_this.inputRef && _this.inputRef.current) {
                _this.inputRef.current.click();
            }
        };
        _this.DownloadResponseOptionsTemplate = function () {
            _this.props.OnDownloadResponseOptionsTemplate();
        };
        _this.HandleUpload = function (event) {
            if (!event.target.files || event.target.files[0] === null) {
                return;
            }
            var selectedFile = event.target.files[0];
            _this.setState({ selectedFile: selectedFile, epoch: Date.now().toString() });
            var data = new FormData();
            data.append('file', selectedFile);
            data.append('ignoreWarnings', 'false');
            if (_this.inputRef && _this.inputRef.current) {
                _this.inputRef.current.value = '';
            }
            _this.props.OnUploadResponseOptions(data, _this.props.sourceResponseOptionGroupId);
            _this.props.SetUploadResponseOptionsState(selectedFile);
        };
        _this.onResponseOptionGroupNameChange = function (e) {
            var UpdateResponseOptionGroupName = _this.props.UpdateResponseOptionGroupName;
            if (UpdateResponseOptionGroupName) {
                UpdateResponseOptionGroupName(e.target.value);
            }
        };
        _this.state = {
            selectedFile: null,
            epoch: '',
        };
        return _this;
    }
    CustomResponseOptionsSection.prototype.render = function () {
        var _a = this.props, multipleToggle = _a.multipleToggle, rankingToggle = _a.rankingToggle, sectionContainer = _a.sectionContainer, showResponseOptionGroupName = _a.showResponseOptionGroupName, responseOptionGroupName = _a.responseOptionGroupName, validationResult = _a.validationResult;
        var validationHelper = new utilities_1.ValidationHelper(validationResult);
        var rogNameValidation = validationHelper.GetValidationResultForProperty(models_1.CustomQuestionPropertyUnderValidation.responseOptionGroupName);
        var responseOptionsValidation = validationHelper.GetValidationResultForProperty(models_1.CustomQuestionPropertyUnderValidation.responseOptions);
        var Container = sectionContainer ? sectionContainer : common_1.Section;
        return (React.createElement(Container, { id: 'create-custom-responseoptions', sectionHeader: contentConstants_1.default.SECTIONHEADERS_CUSTOM_QUESTION_CREATE_RESPONSEOPTION },
            React.createElement(common_1.ColFull, null, contentConstants_1.default.INSTRUCTIONALTEXT_CUSTOMQUESTION_CREATE_RESPONSEOPTION),
            showResponseOptionGroupName && (React.createElement(aon_tws_common_ui_1.ColHalves, { Col1: React.createElement(_1.InnerSectionContainer, { className: 'tws-response-option-group-name', label: contentConstants_1.default.SUBSECTIONHEADERS_RESPONSE_OPTION_NAME },
                    React.createElement(exports.ResponseOptionGroupNameInput, { maxLength: 100, value: responseOptionGroupName, message: rogNameValidation && rogNameValidation.errors, error: rogNameValidation && rogNameValidation.errors && rogNameValidation.errors.length > 0, onChange: this.onResponseOptionGroupNameChange })), Col2: React.createElement(exports.FloatRightDiv, null,
                    React.createElement(aon_tws_common_ui_1.Button, { color: 'secondary', onClick: this.DownloadResponseOptionsTemplate, disabled: this.props.disableDownloadAndUploadResponseOptionTemplateButton },
                        React.createElement(aon_tws_common_ui_1.Icon, { name: 'download' }),
                        " Download Response Option Template"),
                    React.createElement("span", null, "\u00A0"),
                    React.createElement(aon_tws_common_ui_1.Button, { color: 'secondary', onClick: this.UploadResponseOptionsTemplate, disabled: this.props.disableDownloadAndUploadResponseOptionTemplateButton },
                        React.createElement(aon_tws_common_ui_1.Icon, { name: 'upload' }),
                        " Upload Response Options"),
                    React.createElement("span", { style: { display: 'none' } },
                        React.createElement("input", { id: 'file', name: 'file', type: 'file', value: '', ref: this.inputRef, onChange: this.HandleUpload }))) })),
            (rankingToggle || multipleToggle) && (React.createElement(common_1.ColFull, null,
                React.createElement(TogglesContainer, null,
                    rankingToggle && React.createElement(React.Fragment, null, rankingToggle),
                    multipleToggle && React.createElement(React.Fragment, null, multipleToggle)))),
            React.createElement(exports.ResponseOptionsWrapper, null,
                React.createElement(_1.CustomResponseOptionTable, __assign({}, this.props, { minimumResponseOptions: this.props.minimumResponseOptions || 0, defaultCultureCode: 'en-US' })),
                responseOptionsValidation && !responseOptionsValidation.isValid && responseOptionsValidation.errors && (React.createElement(exports.ErrorContainer, { className: 'tws-response-options-error-container' }, responseOptionsValidation.errors.map(function (r, key) { return (React.createElement(exports.ErrorWrapper, { key: key },
                    React.createElement(ErrorMessage_1.ErrorIcon, { name: 'error' }),
                    React.createElement(exports.ErrorMessage, { id: key.toString() }, r))); }))))));
    };
    return CustomResponseOptionsSection;
}(React.Component));
exports.CustomResponseOptionsSection = CustomResponseOptionsSection;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
